import { Form, FormInstance } from "antd";
import { createContext } from "react";

type FormContextProps<T> = {
    initialValues?: T | undefined;
    Form: typeof Form,
    form?: FormInstance,
    onFinish: (values: any) => void,
    onFinishFailed: (values: any) => void,
    debug?: boolean
};

export const createFormContext = <T,>(initialState: FormContextProps<T>) => {
    return createContext(initialState);
}